module.exports = __webpack_public_path__ + "img/phone.736d1d01.svg";